class Reports {

    constructor(httpMethods) {
        this.api = httpMethods;
        this.EP = {
            GET_WAITING_TIMES_STARTING_FROM_ARRIVAL: '/api/reports/waitingTime/services/startingFromArrival',
            GET_WAITING_TIMES_STARTING_FROM_APPOINTMENT_TIME: '/api/reports/waitingTime/services/startingFromAppointmentTime',
            GET_AMOUNT_OF_VISITORS: '/api/reports/visitors/amount',
            GET_AMOUNT_OF_NO_SHOWS: '/api/reports/visitors/no-shows/amount',
            GET_SERVING_TIMES: '/api/reports/servingTime'
        };
    }

    waitingTimesStartingFromArrival(params) {
        let url = this.EP.GET_WAITING_TIMES_STARTING_FROM_ARRIVAL;
        if (params.query !== '') {
            url = url + '?' + params.query;
        }
        return this.api.get(url);
    }

    waitingTimesStartingFromAppointmentTime(params) {
        let url = this.EP.GET_WAITING_TIMES_STARTING_FROM_APPOINTMENT_TIME;
        if (params.query !== '') {
            url = url + '?' + params.query;
        }
        return this.api.get(url);
    }

    amountOfVisitors(params) {
        let url = this.EP.GET_AMOUNT_OF_VISITORS;
        if (params.query !== '') {
            url = url + '?' + params.query;
        }
        return this.api.get(url);
    }

    amountOfNoShows(params) {
        let url = this.EP.GET_AMOUNT_OF_NO_SHOWS;
        if (params.query !== '') {
            url = url + '?' + params.query;
        }
        return this.api.get(url);
    }

    servingTimes(params) {
        let url = this.EP.GET_SERVING_TIMES;
        if (params.query !== '') {
            url = url + '?' + params.query;
        }
        return this.api.get(url);
    }
}

export default Reports;